/* eslint-disable no-console */
import React, { useRef, useState, useEffect, useContext } from 'react';
import { Box, Title, Button, Group, Grid, Center, Image, Space, Text } from '@mantine/core';
import { useForm } from '@mantine/form';
import dayjs from 'dayjs';
import * as duration from 'dayjs/plugin/duration';
import { showNotification } from '@mantine/notifications';
import { useNavigate, useLocation } from 'react-router-dom';
import Keyboard from 'react-simple-keyboard';
import { CircleX, ArrowBackUp } from 'tabler-icons-react';
import 'react-simple-keyboard/build/css/index.css';
import BasicLayout from '../../components/BasicLayout';
import AppContext from '../../components/Context/index';
import OTPInput from '../../components/OTPInput/OTPInput';
import logo from '../../image/hyperthings-logo.png';
import { sendRequest } from '../../services/services';
import { applyKeyboardButton, syncKeyboardValue } from '../../utils/keyboard';

dayjs.extend(duration);

const OTPVerify = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const [seconds, setSeconds] = useState(0);
  const [layout, setLayout] = useState('default');
  const keyboard = useRef();
  const [inputData, setInputData] = useState('');
  const inputDataRef = useRef('');
  inputDataRef.current = inputData;
  const [shiftButtonText, setShiftButtonText] = useState('Arabic');
  const searchParams = new URLSearchParams(search);
  const mobileNumber = searchParams.get('mobile');
  const countryCode = searchParams.get('countryCode');

  const appContextState = useContext(AppContext);
  const { handleUserLogin } = appContextState;

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      // mobile: null,
      country_code_id: 194,
    },
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((value) => {
        if (value > 0) {
          return value - 1;
        }
        return value;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const generateOtp = () => {
    const body = { mobile: mobileNumber, country_code_id: countryCode };
    sendRequest(`cashier/generate-otp`, 'post', body)
      .then(({ data, code }) => {
        setSeconds(60);
        if (code === 20) {
          handleUserLogin(data);
          showNotification({
            title: <Text weight={500}>Success full send OTP</Text>,
          });
        } else if (code === 40) {
          showNotification({
            title: <Text weight={500}>User not registered!</Text>,
            icon: <CircleX size={16} />,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.code}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      });
  };

  const verifyOTP = () => {
    const body = {
      mobile: mobileNumber,
      country_code_id: countryCode,
      otp: inputData,
    };
    sendRequest(`cashier/signin`, 'post', body)
      .then(({ data, code }) => {
        if (code === 20) {
          handleUserLogin(data);
          navigate('/home');
          window.location.reload();
        } else if (code === 40) {
          showNotification({
            title: <Text weight={500}>Invalid OTP!</Text>,
            icon: <CircleX size={16} />,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      });
  };

  const onChangeInputNumber = (value) => {
    const sanitized = String(value).replace(/\D/g, '').slice(0, 4);
    inputDataRef.current = sanitized;
    setInputData(sanitized);
    syncKeyboardValue(keyboard, sanitized);
  };

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
    if (shiftButtonText === 'Arabic') {
      setShiftButtonText('English');
    } else if (shiftButtonText === 'English') {
      setShiftButtonText('Arabic');
    }
  };

  const onKeyPress = (button) => {
    if (button === '{shift}' || button === '{lock}') {
      handleShift();
      return;
    }
    if (button === '{enter}') {
      if (inputDataRef.current.length === 4) {
        verifyOTP();
      }
      return;
    }
    const next = applyKeyboardButton(button, inputDataRef.current, {
      maxLength: 4,
      sanitize: (value) => value.replace(/\D/g, ''),
    });
    inputDataRef.current = next;
    setInputData(next);
    syncKeyboardValue(keyboard, next);
  };

  return (
    <BasicLayout>
      <Box>
        <Grid>
          <Grid.Col span={6} offset={3}>
            <Box
              sx={(theme) => ({
                backgroundColor:
                  theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
                padding: theme.spacing.xl,
                borderRadius: theme.radius.md,
              })}
            >
              <Button onClick={() => navigate('/')}>
                <ArrowBackUp size={30} />
              </Button>
              <Center>
                <Image radius="md" src={logo} alt="Random unsplash image" width="180px" />
              </Center>

              <Center py="sm">
                <Title order={3}>Verify OTP</Title>
              </Center>

              <form onSubmit={form.onSubmit((values) => console.log(values))}>
                {/* <TextInput
                  placeholder="+91 7889675235"
                  {...form.getInputProps('number')}
                  value={dummycharInput}
                  onChange={onCharChange}
                />
                <Center py="lg">
                  <Button onClick={signIn}>Send OTP</Button>
                </Center> */}

                <div style={{ marginTop: '10px' }}>
                  <Center>
                    <div dir="ltr">
                      <OTPInput
                        OTPLength={4}
                        otpType="number"
                        autoFocus
                        inputStyles={{
                          width: '60px',
                          height: '40px',
                          fontSize: '1.5rem',
                          textAlign: 'center',
                          direction: 'ltr',
                        }}
                        value={inputData}
                        onChange={onChangeInputNumber}
                      />
                    </div>
                  </Center>

                  {/* <Anchor component="a" style={{ float: 'right' }} p="xs" onClick={signIn}>
                    Resend OTP
                  </Anchor> */}
                </div>
                <Space h="xl" />
                <Space h="xl" />
                <Center py="xl">
                  <Group>
                    <Button type="submit" style={{ width: '100%' }} onClick={verifyOTP}>
                      Submit OTP
                    </Button>
                    {/* <Anchor component="a" style={{ float: 'left' }} onClick={signIn}>
                      Resend OTP
                    </Anchor> */}

                    {seconds > 0 ? (
                      <Text size="sm">
                        Resend code in {dayjs.duration(seconds * 1000).format('mm:ss')}
                      </Text>
                    ) : (
                      <Button
                        variant="subtle"
                        disabled={seconds > 0}
                        compact
                        onClick={() => {
                          generateOtp();
                        }}
                      >
                        Resend OTP
                      </Button>
                    )}
                  </Group>
                </Center>
              </form>
            </Box>

            <Space h="xl" />

            {/* <Keyboard
              // eslint-disable-next-line no-return-assign
              keyboardRef={(r) => (keyboard.current = r)}
              onChange={onCharChange}
              onKeyPress={onKeyPress}
              layoutName={layout}
              layout={{
                default: ['1 2 3 4 5 6 7 8 9 0 {bksp}'],
                shift: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
              }}
              display={{
                '{bksp}': '⌫',
                '{enter}': 'Enter',
              }}
            /> */}

            <Space h="xl" />

            <div dir="ltr">
              <Keyboard
                // eslint-disable-next-line no-return-assign
                keyboardRef={(r) => (keyboard.current = r)}
                onKeyPress={onKeyPress}
                layoutName={layout}
                maxLength={4}
                preventMouseDownDefault
                disableCaretPositioning
                layout={{
                  default: ['1 2 3 4 5 6 7 8 9 0 {bksp}'],
                  shift: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                }}
                display={{
                  '{bksp}': '⌫',
                  '{enter}': 'Enter',
                }}
              />
            </div>
          </Grid.Col>
        </Grid>
      </Box>
    </BasicLayout>
  );
};

export default OTPVerify;
